//Reset data
export const RESET = "INSTITUTION_UPDATE_RESET"

export const SET_IS_UPDATED = "INSTITUTION_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "INSTITUTION_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "INSTITUTION_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "INSTITUTION_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "INSTITUTION_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "INSTITUTION_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "INSTITUTION_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "INSTITUTION_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "INSTITUTION_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "INSTITUTION_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "INSTITUTION_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "INSTITUTION_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "INSTITUTION_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "INSTITUTION_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "INSTITUTION_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "INSTITUTION_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "INSTITUTION_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "INSTITUTION_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "INSTITUTION_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "INSTITUTION_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "INSTITUTION_UPDATE_SET_MODAL_TYPE"